module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberaudorf/profile-ca6a2ae12332506988c12b4fb493f358.jpg";